// frontend/app/components/admin/LessonLibraryFilters.js
//
// What an admin narrows the library by: free text, board, status.
//
// Text is submitted, boards and statuses apply on press. The difference is
// deliberate — a half-typed word is not a query worth a round trip, but there
// is no half-pressed chip.

import React from "react";
import { StyleSheet, Text, TextInput, TouchableOpacity, View } from "react-native";

import { ChipSelect } from "../lessonPlans/authoring/WizardFields";
import { LESSON_BOARDS, LESSON_STATUSES } from "./lessonAdminDraft";

const ALL = "";

const boardOptions = [
  { value: ALL, label: "All boards" },
  ...LESSON_BOARDS.map((board) => ({ value: board, label: board.toUpperCase() })),
];

const statusOptions = [
  { value: ALL, label: "Any status" },
  ...LESSON_STATUSES.map((status) => ({
    value: status,
    label: status[0].toUpperCase() + status.slice(1),
  })),
];

const LessonLibraryFilters = ({
  colors,
  queryText,
  board,
  status,
  onQueryTextChange,
  onSubmit,
  onBoardChange,
  onStatusChange,
}) => (
  <View style={styles.wrap}>
    <View style={styles.searchRow}>
      <TextInput
        value={queryText}
        onChangeText={onQueryTextChange}
        onSubmitEditing={onSubmit}
        returnKeyType="search"
        placeholder="Search title, topic or slug"
        placeholderTextColor={colors.textMuted}
        accessibilityLabel="Search lessons"
        style={[
          styles.search,
          {
            backgroundColor: colors.panelBg,
            borderColor: colors.borderStrong,
            color: colors.textPrimary,
          },
        ]}
      />
      <TouchableOpacity
        onPress={onSubmit}
        accessibilityRole="button"
        style={[styles.searchBtn, { backgroundColor: colors.accentPrimary }]}
      >
        <Text style={styles.searchBtnText}>Search</Text>
      </TouchableOpacity>
    </View>

    <View style={styles.chipGroup}>
      <Text style={[styles.chipGroupLabel, { color: colors.textSecondary }]}>Board</Text>
      <ChipSelect
        colors={colors}
        options={boardOptions}
        value={board}
        onChange={onBoardChange}
        accessibilityLabel="Filter by board"
      />
    </View>

    <View style={styles.chipGroup}>
      <Text style={[styles.chipGroupLabel, { color: colors.textSecondary }]}>Status</Text>
      <ChipSelect
        colors={colors}
        options={statusOptions}
        value={status}
        onChange={onStatusChange}
        accessibilityLabel="Filter by status"
      />
    </View>
  </View>
);

const styles = StyleSheet.create({
  wrap: { marginBottom: 12 },
  searchRow: { flexDirection: "row", alignItems: "center", gap: 8, marginBottom: 10 },
  search: {
    flex: 1,
    minWidth: 200,
    height: 38,
    borderRadius: 9,
    borderWidth: 1,
    paddingHorizontal: 12,
    fontSize: 13,
  },
  searchBtn: {
    height: 38,
    borderRadius: 9,
    paddingHorizontal: 16,
    alignItems: "center",
    justifyContent: "center",
  },
  searchBtnText: { color: "#fff", fontWeight: "700", fontSize: 12 },

  chipGroup: { flexDirection: "row", alignItems: "center", gap: 10, marginBottom: 8 },
  chipGroupLabel: {
    fontSize: 10,
    fontWeight: "800",
    letterSpacing: 0.5,
    textTransform: "uppercase",
    width: 52,
  },
});

export default LessonLibraryFilters;
